// Pure helpers for the admin section shells (AI Studio, Money, Email, Social, Settings).

// Unknown or missing ?tab= falls back to the first tab. `aliases` maps old tab ids
// (and old page names) to the current tab id so existing deep links keep working.
export function resolveSectionTab(tabs, value, aliases = {}) {
  const ids = (tabs || []).filter((t) => !t.href).map((t) => t.id);
  if (!ids.length) return undefined;
  const id = aliases[value] || value;
  return ids.includes(id) ? id : ids[0];
}

export function sectionTabHref(searchParams, tabId) {
  const next = new URLSearchParams(searchParams ? searchParams.toString() : "");
  next.set("tab", tabId);
  return `?${next.toString()}`;
}

// Old admin URLs -> their tab in the merged sections. Used by App.js redirects.
export const SECTION_REDIRECTS = {
  // Money
  "/crm/finance": "/crm/money?tab=observations",
  "/finance": "/crm/money?tab=observations",
  "/crm/finance/imports": "/crm/money?tab=imports",
  "/finance/imports": "/crm/money?tab=imports",
  "/crm/revenue": "/crm/money?tab=revenue",
  "/revenue": "/crm/money?tab=revenue",
  "/crm/expenses": "/crm/money?tab=expenses",
  "/expenses": "/crm/money?tab=expenses",
  "/crm/leaderboard": "/crm/money?tab=leaderboard",
  "/money": "/crm/money",
  // AI Studio
  "/crm/ai-manager": "/crm/ai?tab=today",
  "/ai-manager": "/crm/ai?tab=today",
  "/crm/ai-workers": "/crm/ai?tab=campaigns",
  "/crm/chat": "/crm/ai?tab=copilot",
  "/chat": "/crm/ai?tab=copilot",
  "/ai": "/crm/ai",
  "/crm/ai-studio": "/crm/ai",
  // Email
  "/crm/emails": "/crm/email?tab=compose",
  "/emails": "/crm/email",
  "/email": "/crm/email",
  "/crm/privacy-email": "/crm/email?tab=privacy",
  // Social
  "/social": "/crm/social?tab=tracker",
  "/crm/multi-tracker": "/crm/social?tab=tracker",
  "/crm/instagram": "/crm/social?tab=instagram",
  "/instagram": "/crm/social?tab=instagram",
  "/platform-hubs/instagram": "/crm/social?tab=instagram",
  // Settings
  "/settings": "/crm/settings",
  "/crm/ai-settings": "/crm/settings?tab=ai",
  "/crm/design-settings": "/crm/settings?tab=brand",
  "/crm/roles": "/crm/settings?tab=roles",
  "/crm/activity": "/crm/settings?tab=activity",
};

// "/crm/money?tab=revenue" + "?source=manual" -> "/crm/money?source=manual&tab=revenue".
// The target's own params (the tab) win over the old URL's params.
export function mergeRedirectTarget(to, search = "", hash = "") {
  const [path, query = ""] = String(to).split("?");
  const merged = new URLSearchParams(search || "");
  new URLSearchParams(query).forEach((value, key) => merged.set(key, value));
  const qs = merged.toString();
  return `${path}${qs ? `?${qs}` : ""}${hash || ""}`;
}
